export const chartOfAccountsTranslations = {
  ar: {
    title: 'دليل الحسابات',
    addNew: 'اضافة جديد',
    delete: 'حذف',
    close: 'غلق',
    open: 'فتح',
    search: 'بحث...',
    name: 'الاسم',
    nameEn: 'الاسم (إنجليزي)',
    accountType: 'نوع الحساب',
    parentAccount: 'الحساب الأب',
    balance: 'الرصيد',
    edit: 'تعديل',
    deleteAction: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    noAccounts: 'لا توجد حسابات',
    loading: 'جاري تحميل دليل الحسابات...',
    error: 'فشل تحميل دليل الحسابات',
    saveSuccess: 'تم حفظ الحساب بنجاح',
    saveError: 'فشل حفظ الحساب',
    deleteSuccess: 'تم حذف الحساب بنجاح',
    deleteError: 'فشل حذف الحساب',
    moveSuccess: 'تم نقل الحساب بنجاح',
    moveError: 'فشل نقل الحساب',
    cannotMoveParent: 'لا يمكن نقل الحساب الأب. يجب حذف أو نقل جميع الأبناء أولاً',
    copy: 'نسخ',
    paste: 'لصق',
    copySuccess: 'تم نسخ الحساب بنجاح',
    pasteSuccess: 'تم لصق الحساب بنجاح',
    pasteError: 'فشل لصق الحساب',
    noAccountCopied: 'لم يتم نسخ أي حساب',
    selectAccountToCopy: 'يرجى تحديد حساب للنسخ',
  },
  en: {
    title: 'Chart of Accounts',
    addNew: 'Add New',
    delete: 'Delete',
    close: 'Close',
    open: 'Open',
    search: 'Search...',
    name: 'Name',
    nameEn: 'Name (English)',
    accountType: 'Account Type',
    parentAccount: 'Parent Account',
    balance: 'Balance',
    edit: 'Edit',
    deleteAction: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    noAccounts: 'No accounts',
    loading: 'Loading chart of accounts...',
    error: 'Failed to load chart of accounts',
    saveSuccess: 'Account saved successfully',
    saveError: 'Failed to save account',
    deleteSuccess: 'Account deleted successfully',
    deleteError: 'Failed to delete account',
    moveSuccess: 'Account moved successfully',
    moveError: 'Failed to move account',
    cannotMoveParent: 'Cannot move parent account. Please delete or move all children first',
    copy: 'Copy',
    paste: 'Paste',
    copySuccess: 'Account copied successfully',
    pasteSuccess: 'Account pasted successfully',
    pasteError: 'Failed to paste account',
    noAccountCopied: 'No account copied',
    selectAccountToCopy: 'Please select an account to copy',
  },
  fr: {
    title: 'Plan comptable',
    addNew: 'Ajouter nouveau',
    delete: 'Supprimer',
    close: 'Fermer',
    open: 'Ouvrir',
    search: 'Rechercher...',
    name: 'Nom',
    nameEn: 'Nom (anglais)',
    accountType: 'Type de compte',
    parentAccount: 'Compte parent',
    balance: 'Solde',
    edit: 'Modifier',
    deleteAction: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    noAccounts: 'Aucun compte',
    loading: 'Chargement du plan comptable...',
    error: 'Échec du chargement du plan comptable',
    saveSuccess: 'Compte enregistré avec succès',
    saveError: 'Échec de l\'enregistrement du compte',
    deleteSuccess: 'Compte supprimé avec succès',
    deleteError: 'Échec de la suppression du compte',
    moveSuccess: 'Compte déplacé avec succès',
    moveError: 'Échec du déplacement du compte',
    cannotMoveParent: 'Impossible de déplacer le compte parent. Veuillez d\'abord supprimer ou déplacer tous les enfants',
    copy: 'Copier',
    paste: 'Coller',
    copySuccess: 'Compte copié avec succès',
    pasteSuccess: 'Compte collé avec succès',
    pasteError: 'Échec du collage du compte',
    noAccountCopied: 'Aucun compte copié',
    selectAccountToCopy: 'Veuillez sélectionner un compte à copier',
  },
}


